import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
import md5 from 'md5';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            activeTab: 1,
            logoimg: '',
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            linkaff: "",
            point: 0,
            useradvice: [],
            balance: 0,
            loginstate: null,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            username: "",
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            name: "",
            password: "",
            left: false,
        }
    }
    logout = (e) => {

        // window.location.href = '/logout';

    }
    async componentDidMount() {
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value,
                    logoimg: res.data.tblsetting[0].imglogo,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });

        try {
            var token = localStorage.getItem('auth_token');
            if (token != null) {
                var decoded = jwt_decode(token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            }
            else {
                this.setState({
                    loginstate: false,
                });
            }
        }
        catch (error) {
            //////console.log();
        }

    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }
    async checkuseradvice() {
        instance.post("/api/v1/checkuseradvice", {
            User_id: this.state.username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log(res.data.message.useradvicelist);
                this.setState({
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }



 

    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //  this.rechecklogin(Username, token);
        this.setState({
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            //  console.log(5);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                    var i, tablinks;
                    tablinks = document.getElementsByClassName("-btn-balance");
                    for (i = 0; i < tablinks.length; i++) {
                        tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
                    }
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    //   console.log(res.data);
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                //    console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    render() {

        const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
        // //////console.log(this.state);
        return (
            <>
                <div >
                    <nav className="x-header navbar navbar-expand-lg -anon">
                        <div className="container-fluid align-items-center h-100 position-relative">
                            <div id="headerBrand">
                                <button type="button" className="btn bg-transparent p-0 x-hamburger js-hamburger-toggle" data-toggle="modal" data-target="#websiteMenuModal">
                                    <span />
                                    <span />
                                    <span />
                                </button>
                                <a className="navbar-brand" href="/">
                                    <img className="-logo" src={this.state.logoimg} alt="Casino slot online logo" />
                                </a>
                            </div>
                            <div className="x-menu">
                                <div className="-menu-container">
                                    <a href="/invitation" className="-menu-link ">
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-invitation.png"
                                        />
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon -active img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-invitation-active.png"
                                        />
                                        <span>ชวนเพื่อน</span>
                                    </a>
                                    <a href="/promotion" className="-menu-link ">
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-promotion.png?v=2"
                                        />
                                        <img
                                            alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                            className="-icon -active img-fluid"
                                            width={40}
                                            height={40}
                                            src="/build/web/igame-index-lobby-wm/img/ic-menu-promotion-active.png?v=2"
                                        />
                                        <span>โปรโมชั่น</span>
                                    </a>
                                </div>
                            </div>

                            <div id="headerContent">
                                <div className="d-flex">
                                    <a
                                        href={this.state.linelink}
                                        className="x-header-btn-support -in-anon "
                                        target="_blank"
                                        rel="noreferrer nofollow"
                                    >
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic"
                                                width={120}
                                                height={39}
                                                src="/build/web/igame-index-lobby-wm/img/ic-telegram-support.png?v=4"
                                            />
                                        </picture>
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support-mobile.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-telegram-support-mobile.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic -mobile"
                                                width={28}
                                                height={28}
                                                src="/build/web/igame-index-lobby-wm/img/ic-telegram-support-mobile.png?v=4"
                                            />
                                        </picture>
                                    </a>
                                    <a
                                        href={this.state.linelink}
                                        className="x-header-btn-support -in-anon "
                                        target="_blank"
                                        rel="noreferrer nofollow"
                                    >
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic"
                                                width={120}
                                                height={39}
                                                src="/build/web/igame-index-lobby-wm/img/ic-line-support.png?v=4"
                                            />
                                        </picture>
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support-mobile.webp?v=4"
                                            />
                                            <source
                                                type="image/png?v=4"
                                                srcSet="/build/web/igame-index-lobby-wm/img/ic-line-support-mobile.png?v=4"
                                            />
                                            <img
                                                alt="หวยออนไลน์ สล็อตออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                className="img-fluid -ic -mobile"
                                                width={28}
                                                height={28}
                                                src="/build/web/igame-index-lobby-wm/img/ic-line-support-mobile.png?v=4"
                                            />
                                        </picture>
                                    </a>
                                    {(loginstate != null) ? (!loginstate) ?
                                        <>
                                            <div id="js-button-view-mode-content" className="d-none">
                                                <div className="x-intro-view-mode-container">
                                                    <button type="button" className="btn -btn-view-mode -btn-intro">
                                                        <img
                                                            alt="หวยออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                            className="-icon img-fluid"
                                                            width={26}
                                                            height={26}
                                                            src="/build/web/igame-index-lobby-wm/img/ic-view-mode-casino.png?v=4"
                                                        />
                                                        <span className="-view-text">Casino</span>
                                                    </button>
                                                    <div className="-text-intro-view-mode">
                                                        สามารถเปลี่ยนโหมด
                                                        <br />
                                                        ที่คุณสนใจได้
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="js-button-view-mode-content-hover" className="d-none">
                                                <div className="x-intro-view-mode-container">
                                                    <div className="-text-intro-view-mode">
                                                        สามารถเปลี่ยนโหมด
                                                        <br />
                                                        ที่คุณสนใจได้
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn -btn-view-mode js-button-view-mode"
                                                data-toggle="modal"
                                                data-target="#viewModeModal"
                                                data-dismiss="modal"
                                            >
                                                <img
                                                    alt="หวยออนไลน์ แทงหวยออนไลน์ เว็บพนันออนไลน์"
                                                    className="-icon img-fluid"
                                                    width={26}
                                                    height={26}
                                                    src="/build/web/igame-index-lobby-wm/img/ic-view-mode-casino.png?v=4"
                                                />
                                                <span className="-view-text">Casino</span>
                                            </button>
                                            <a
                                                href="javascript:void(0)"
                                                className="-btn-header-register btn mr-1 mr-sm-2"
                                                data-toggle="modal"
                                                data-target="#registerModal"
                                            >
                                                สมัครสมาชิก
                                            </a>
                                            <a
                                                href="javascript:void(0)"
                                                className="-btn-header-login btn"
                                                data-toggle="modal"
                                                data-target="#loginModal"
                                            >
                                                เข้าสู่ระบบ
                                            </a>
                                        </>
                                        :

                                        <div className="x-logged">
                                            <div className="-profile-outer-container -has-vip-mode">
                                                <div className="-balance-container">
                                                    <div className="-text-username">0909745451</div>
                                                    <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                        <div className="-inner-box-wrapper">
                                                            <span id="customer-balance" className="js-customer-balance">
                                                                <span className="text-green-lighter">0.00</span>
                                                            </span>
                                                            <button
                                                                type="button"
                                                                id="btn-customer-balance-reload"
                                                                className="-btn-balance -in-box"
                                                                data-loading="_onReloadBalance_"
                                                                data-done="_onReloadBalanceDone_"
                                                                data-ajax-href="/account/_ajax_/get-balance?reload=1"
                                                                data-target="#customer-balance, .js-customer-balance"
                                                            >
                                                                <i className="fas fa-sync-alt f-9" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="-profile-container">
                                                    <a
                                                        href="#account"
                                                        data-toggle="modal"
                                                        data-target="#accountModal"
                                                        className="-btn-wrapper"
                                                    >
                                                        <div className="x-profile-image">
                                                            <img
                                                                className="img-fluid -profile-image"
                                                                src="https://cdn.javisx.com/image/b3dbc674-2f35-4b6b-b5f0-ce92622b50c5.png"
                                                                alt="customer image"
                                                            />
                                                        </div>
                                                    </a>
                                                    <div className="d-xl-none d-block">
                                                        <div className="js-ez-logged-sidebar">
                                                            <div className="x-profile-image">
                                                                <img
                                                                    className="img-fluid -profile-image"
                                                                    src="https://cdn.javisx.com/image/b3dbc674-2f35-4b6b-b5f0-ce92622b50c5.png"
                                                                    alt="customer image"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="x-menu-account-list-sidebar">
                                                            <div className="x-modal-account-menu-mobile">
                                                                <div className="-modal-profile-mobile -vip d-block d-xl-none">
                                                                    <div className="text-right">
                                                                        <i className="fas fa-times f-5 js-close-account-sidebar" />
                                                                    </div>
                                                                    <a href="/" className="-btn-logo">
                                                                        <img
                                                                            alt="AE SEXY Image"
                                                                            className="img-fluid lazyload -img"
                                                                            width={121}
                                                                            height={45}
                                                                            data-src="/build/web/igame-index-lobby-wm/img/logo.png?v=2"
                                                                            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                                                        />
                                                                    </a>
                                                                    <p className="-group-name">0909745451</p>
                                                                    <div className="-balance-container">
                                                                        <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                            <div className="-inner-box-wrapper">
                                                                                <span id="customer-balance" className="js-customer-balance">
                                                                                    <span className="text-green-lighter">0.00</span>
                                                                                </span>
                                                                                <button
                                                                                    type="button"
                                                                                    id="btn-customer-balance-reload"
                                                                                    className="-btn-balance -in-box "
                                                                                    data-loading="_onReloadBalance_"
                                                                                    data-done="_onReloadBalanceDone_"
                                                                                    data-ajax-href="/account/_ajax_/get-balance?reload=1"
                                                                                    data-target="#customer-balance, .js-customer-balance"
                                                                                >
                                                                                    <i className="fas fa-sync-alt f-9" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="-transaction-button-wrapper"></div>
                                                                <ul className="navbar-nav">
                                                                    <li className="nav-item -account-profile">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -account-profile"
                                                                            data-toggle="modal"
                                                                            data-target="#accountModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="ข้อมูลบัญชี หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-user.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">ข้อมูลบัญชี</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -account-link-social">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -account-link-social"
                                                                            data-toggle="modal"
                                                                            data-target="#linkSocialAccountModalMobile"
                                                                        >
                                                                            <div className="-text-menu-wrapper">
                                                                                <img
                                                                                    alt="ข้อมูลบัญชี หวยออนไลน์ แทงหวยออนไลน์"
                                                                                    className="img-fluid -icon-image"
                                                                                    width={35}
                                                                                    height={35}
                                                                                    src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-account-menu-link-social-media.png"
                                                                                />
                                                                                <span className="-text-menu">โซเชียล</span>
                                                                            </div>
                                                                            <div className="-text-menu -highlight">ฟรี 25 บาท!</div>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -account-pocket-farm">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -account-pocket-farm"
                                                                            data-toggle="modal"
                                                                            data-target="#pocketFarmModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="PocketFarm ฝากดอก ออกผล ดอกเบี้ย 10% ง่ายๆ"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-pocket-farm.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">Pocket Farm</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -account-bill-history">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -account-bill-history"
                                                                            data-toggle="modal"
                                                                            data-target="#billHistoryModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="ประวัติ หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-bill-history.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">ประวัติ</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -account-provider">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -account-provider"
                                                                            data-toggle="modal"
                                                                            data-target="#providerUserModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="เข้าเล่นผ่านแอพ หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-provider.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">เข้าเล่นผ่านแอพ</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -coupon js-account-approve-aware">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -coupon js-account-approve-aware"
                                                                            data-toggle="modal"
                                                                            data-target="#couponModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="ใช้คูปอง หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-coupon.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">ใช้คูปอง</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -join-promotion">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -join-promotion"
                                                                            data-toggle="modal"
                                                                            data-target="#joinPromotionModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="โปรโมชั่นที่เข้าร่วม หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-promotion.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">โปรโมชั่นที่เข้าร่วม</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -promotion-return-by-user">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar -promotion-return-by-user"
                                                                            data-toggle="modal"
                                                                            data-target="#promotionReturnByUserModalMobile"
                                                                        >
                                                                            <img
                                                                                alt="โบนัสเพิ่ม ทุกสัปดาห์ หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-bonus.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">โบนัสเพิ่ม ทุกสัปดาห์</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -logout">
                                                                        <a
                                                                            className="nav-link js-require-confirm  -logout"
                                                                            href="/logout"
                                                                            data-title="ต้องการออกจากระบบ ?"
                                                                        >
                                                                            <img
                                                                                alt="ออกจากระบบ หวยออนไลน์ แทงหวยออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                width={35}
                                                                                height={35}
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-account-menu-logout.png?v=2"
                                                                            />
                                                                            <span className="-text-menu">ออกจากระบบ</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="-overlay" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="-deposit-container d-none d-lg-block">
                                                <a
                                                    href="#deposit-choose-promotion"
                                                    className="text-white js-account-approve-aware btn -btn-deposit"
                                                    data-toggle="modal"
                                                    data-target="#depositChoosePromotionModal"
                                                >
                                                    <div className="f-7">ฝากเงิน</div>
                                                </a>
                                            </div>
                                            <div className="-withdraw-container d-none d-lg-block">
                                                <a
                                                    href="#withdraw"
                                                    className="text-white js-account-approve-aware btn -btn-withdraw"
                                                    data-toggle="modal"
                                                    data-target="#withdrawModal"
                                                >
                                                    <div className="f-7">ถอนเงิน</div>
                                                </a>
                                            </div>



                                        </div> : ""
                                    }
                                </div>

                                {/* <div className="navbar-nav">
                                    {(loginstate != null) ? (!loginstate) ?
                                        <div className="d-flex x-anon ">
                                            <a href="#loginModal" className="btn -btn-header-login" data-toggle="modal" data-target="#loginModal">
                                               
                                                <span className="-text-btn">เข้าสู่ระบบ</span>
                                            </a>
                                        </div>
                                        :
                                        <div className="x-logged">
                                            <div className="-deposit-container d-none d-lg-block">
                                                <a
                                                    href="#deposit-choose-promotion"
                                                    className="text-white js-account-approve-aware btn -btn-deposit"
                                                    data-toggle="modal"
                                                    data-target="#depositChoosePromotionModal"
                                                >
                                                    <div className="f-7">ฝากเงิน</div>
                                                </a>
                                            </div>
                                            <div className="-withdraw-container d-none d-lg-block">
                                                <a
                                                    href="#withdraw"
                                                    className="text-white js-account-approve-aware btn -btn-withdraw"
                                                    data-toggle="modal"
                                                    data-target="#withdrawModal"
                                                >
                                                    <div className="f-7">ถอนเงิน</div>
                                                </a>
                                            </div>
                                            <div className="-profile-container ">
                                                <div className="d-none d-lg-block">
                                                    <div className="-btn-wrapper">
                                                        <div className="-inner-wrapper">
                                                            <a
                                                                href="#account"
                                                                data-toggle="modal"
                                                                data-target="#accountModal"
                                                                className="text-decoration-none"
                                                            >
                                                                <div className="-profile-name">{username}</div>
                                                            </a>
                                                            <div className="-balance-container">
                                                                <div className="-text-username">{username}</div>
                                                                <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                    <div className="-inner-box-wrapper">
                                                                        <img
                                                                            className="img-fluid -ic-coin"
                                                                            src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                            alt=""
                                                                            width={26}
                                                                            height={21}
                                                                        />
                                                                        <span className="js-customer-balance" id="customer-balance">
                                                                            {" "}
                                                                            <span className="-amount"> <NumericFormat value={balance} displayType={'text'} thousandSeparator={true} /> </span>
                                                                        </span>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        className="-btn-balance"
                                                                        id="btn-customer-balance-reload"
                                                                        onClick={(e) => {
                                                                            this.recheccredit(e)
                                                                        }}
                                                                        data-target="#customer-balance"
                                                                    >
                                                                        <i className="fas fa-sync-alt f-9" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a href="#account" data-toggle="modal" data-target="#accountModal">
                                                            <div className="x-profile-image">
                                                                <img
                                                                    className="img-fluid -profile-image"
                                                                    src={"/build/rank/" + this.state.rankpic}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="d-lg-none">
                                                    <div className="js-ez-logged-sidebar -btn-mobile-wrapper">
                                                        <div className="-inner-wrapper">
                                                            <a href={() => false}
                                                                className="text-decoration-none">
                                                                <div className="-profile-name">{username}</div>
                                                            </a>
                                                            <div className="-balance-container">
                                                                <div className="-text-username">{username}</div>
                                                                <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                    <div className="-inner-box-wrapper">


                                                                        <img
                                                                            className="img-fluid -ic-coin"
                                                                            src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                            alt=""
                                                                            width={26}
                                                                            height={21}
                                                                        />
                                                                        <span className="js-customer-balance" id="customer-balance">
                                                                            {" "}
                                                                            <span className="-amount">{<NumericFormat value={balance} displayType={'text'} thousandSeparator={true} />}</span>
                                                                        </span>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        className="-btn-balance"
                                                                        id="btn-customer-balance-reload"
                                                                        onClick={(e) => {
                                                                            this.recheccredit(e)
                                                                        }}
                                                                        data-target="#customer-balance"
                                                                    >
                                                                        <i className="fas fa-sync-alt f-9" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <a href={() => false}
                                                            onClick={this.openAccout} >
                                                            <div className="x-profile-image">
                                                                <img
                                                                    className="img-fluid -profile-image"
                                                                    src={"/build/rank/" + this.state.rankpic}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="x-menu-account-list-sidebar">
                                                        <div className="x-modal-account-menu-mobile">
                                                            <div className="-modal-profile-mobile d-xl-none d-block">
                                                                <div className="text-right">
                                                                    <a href="#account" onClick={this.openAccoutcan}>
                                                                        <i className="fas fa-times f-5 js-close-account-sidebar" />
                                                                    </a>
                                                                </div>
                                                                <div className="x-profile-image">
                                                                    <img
                                                                        className="img-fluid -profile-image"
                                                                        src={"/build/rank/" + this.state.rankpic}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div className="-balance-container">
                                                                    <div className="-text-username">{username}</div>
                                                                    <div className="-user-balance js-user-balance f-sm-6 f-7 ">
                                                                        <div className="-inner-box-wrapper">
                                                                            <img
                                                                                className="img-fluid -ic-coin"
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                alt=""
                                                                                width={26}
                                                                                height={21}
                                                                            />
                                                                            <span className="js-customer-balance" id="customer-balance">
                                                                                {" "}
                                                                                <span className="-amount">{balance}</span>
                                                                            </span>
                                                                        </div>
                                                                        <button
                                                                            type="button"
                                                                            className="-btn-balance"
                                                                            id="btn-customer-balance-reload"
                                                                            onClick={(e) => {
                                                                                this.recheccredit(e)
                                                                            }}
                                                                            data-target="#customer-balance"
                                                                        >
                                                                            <i className="fas fa-sync-alt f-9" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="-lists-outer-wrapper">
                                                                <ul className="navbar-nav">
                                                                    <li className="nav-item -account-profile">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar "
                                                                            data-toggle="modal"
                                                                            data-target="#accountModalMobile"
                                                                        >
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-user.png"
                                                                                className="img-fluid -icon-image"
                                                                                alt="ic-menu-account-user"
                                                                            />
                                                                            <span className="-text-menu">ข้อมูลบัญชี</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -account-provider">
                                                                        <button
                                                                            onClick={(e) => {
                                                                                this.checkuseradvice()
                                                                            }}
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar "
                                                                            data-toggle="modal"
                                                                            data-target="#providerUserModalMobile"
                                                                        >
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-provider.png"
                                                                                className="img-fluid -icon-image"
                                                                                alt="ic-menu-account-provider"
                                                                            />
                                                                            <span className="-text-menu">ชวนเพื่อน</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -menu-item -account-bill-history">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar "
                                                                            data-toggle="modal"
                                                                            data-target="#historyModal"
                                                                        >
                                                                            <img
                                                                                alt="เมนูใช้งานของผู็ใช้บนเว็บคาสิโนออนไลน์ สล็อตออนไลน์"
                                                                                className="img-fluid -icon-image"
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bill-history.png?v=5"
                                                                            />
                                                                            <span className="-text-menu">ประวัติทำรายการ</span>
                                                                        </button>
                                                                    </li>


                                                                    <li className="nav-item -coupon">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar js-account-approve-aware"
                                                                            data-toggle="modal"
                                                                            data-target="#couponModalMobile"
                                                                        >
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-coupon.png"
                                                                                className="img-fluid -icon-image"
                                                                                alt="ic-menu-account-coupon"
                                                                            />
                                                                            <span className="-text-menu">ใช้คูปอง</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -join-promotion">
                                                                        <button
                                                                            type="button"
                                                                            onClick={(e) => {
                                                                                this.checkpro(e, 999)
                                                                            }}
                                                                            className="nav-link js-close-account-sidebar "
                                                                            data-toggle="modal"
                                                                            data-target="#joinPromotionModalMobile"
                                                                        >
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-promotion.png"
                                                                                className="img-fluid -icon-image"
                                                                                alt="ic-menu-account-promotion"
                                                                            />
                                                                            <span className="-text-menu">โปรโมชั่นที่เข้าร่วม</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -promotion-return-by-user">
                                                                        <button
                                                                            type="button"
                                                                            className="nav-link js-close-account-sidebar "
                                                                            data-toggle="modal"
                                                                            data-target="#promotionReturnByUserModalMobile"
                                                                        >
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bonus.png"
                                                                                className="img-fluid -icon-image"
                                                                                alt="ic-menu-account-bonus"
                                                                            />
                                                                            <span className="-text-menu">รับคืนยอดเสีย</span>
                                                                        </button>
                                                                    </li>
                                                                    <li className="nav-item -logout">
                                                                        <a
                                                                            href="/logout"
                                                                            className="nav-link js-require-confirm"
                                                                            data-title="ต้องการออกจากระบบ ?"
                                                                        >
                                                                            <img
                                                                                className="img-fluid -icon-image"
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-menu-account-logout.png"
                                                                                alt="ic-menu-account-logout"
                                                                            />
                                                                            <span className="-text-menu">ออกจากระบบ</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                                <ul className="navbar-nav -action-nav">
                                                                    <li className="nav-item">
                                                                        <a
                                                                            href={() => false}
                                                                            onClick={this.onClick}
                                                                            className="nav-link js-close-account-sidebar"
                                                                            data-toggle="modal"
                                                                            data-target="#bookmarkModal"
                                                                        >
                                                                            <img
                                                                                src="/build/web/igame-index-lobby-wm/img/ic-bookmark-square.png"
                                                                                className="-img"
                                                                                alt="คาสิโนออนไลน์ สล็อตออนไลน์ บาคาร่าออนไลน์ อันดับ 1"
                                                                                width={100}
                                                                                height={100}
                                                                            />
                                                                            <div className="-text">Bookmark</div>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="-overlay" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""
                                    }
                                </div> */}
                            </div>
                        </div>

                    </nav>
                    <div
                        className="x-modal modal -v2 show"
                        id="joinPromotionModalMobile"
                        tabIndex={-1}
                        role="dialog"
                        data-container="#joinPromotionModalMobile"
                        aria-modal="true"
                    >
                        <div
                            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button -no-padding-x"
                            role="document"
                        >
                            <div className="modal-content -modal-content">
                                <button
                                    type="button"
                                    className="close f-1 "
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="fas fa-times" />
                                </button>
                                <div className="modal-header -modal-header">
                                    <div className="x-modal-mobile-header">
                                        <div className="-header-mobile-container">
                                            <h3 className="x-title-modal mx-auto text-center d-inline-block">
                                                การเข้าร่วมโปรโมชั่น
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body -modal-body">
                                    <div className="-outer-history-wrapper">
                                        <div className="x-bill-history-container">
                                            <div
                                                className="wg-container wg-container__wg_bill_history wg--loaded"
                                                data-widget-name="wg_bill_history"
                                                data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                                data-widget-user-options='{"page":1}'
                                            >
                                                <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "" : "none" }}>
                                                    <div className="-no-result-wrapper mt-3">
                                                        <div className="-heading-title">
                                                            <i className="fas fa-times-circle -icon" />
                                                            <div className="-title">ไม่พบข้อมูล</div>
                                                            <div className="-sub-title">คุณยังไม่มีข้อมูลการทำรายการค่ะ</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "none" : "" }}>
                                                    <table className="table table-borderless table-striped">
                                                        <tbody>
                                                            {proderedeemlist.map((listitem, i) => (
                                                                <tr key={i} id={i}>
                                                                    <td className="-description-body-wrapper">
                                                                        <div className="-title-wrapper">
                                                                            <span className="-title">{listitem.proname}</span>
                                                                            <span style={{ display: (listitem.status === 1) ? "" : "none", margin: "5px" }}>
                                                                                <a href="#0"
                                                                                    onClick={(e) => {
                                                                                        this.cancelredeempromotion(e, listitem)
                                                                                    }}
                                                                                    className="-link-change-password" ><u>ยกเลิก</u></a>
                                                                            </span>
                                                                        </div>
                                                                        <div className="-state-wrapper" style={{ display: (listitem.status === 1) ? "" : "none" }}>
                                                                            <span className="-state-text">สถานะ : </span>
                                                                            <i className="fas fa-spinner fa-spin"></i>
                                                                            <span className="-state-title">รอดำเนินการ</span>
                                                                            <span className="-state-title -short">รอดำเนินการ  </span>
                                                                        </div>
                                                                        <div className="-state-wrapper" style={{ display: (listitem.status === 4) ? "" : "none" }}>
                                                                            <span className="-state-text">สถานะ : </span>
                                                                            <img
                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                                className="-ic"
                                                                                alt=""
                                                                            />
                                                                            <span className="-state-title">ยกเลิก (ยกเลิกโดยผู้เล่น)</span>
                                                                            <span className="-state-title -short">ยกเลิก (โดยผู้เล่น)</span>
                                                                        </div>
                                                                        <div className="-state-wrapper" style={{ display: (listitem.status === 3) ? "" : "none" }}>
                                                                            <span className="-state-text">สถานะ : </span>
                                                                            <img
                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                                                                className="-ic"
                                                                                alt=""
                                                                            />
                                                                            <span className="-state-title">ไม่สำเร็จ (โดยระบบ)</span>
                                                                            <span className="-state-title -short">ไม่สำเร็จ (โดยระบบ)</span>
                                                                        </div>
                                                                        <div className="-state-wrapper" style={{ display: (listitem.status === 2) ? "" : "none" }}>
                                                                            <span className="-state-text">สถานะ : </span>
                                                                            <img
                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                                                                className="-ic"
                                                                                alt=""
                                                                            />
                                                                            <span className="-state-title">สำเร็จ</span>
                                                                            <span className="-state-title -short">สำเร็จ</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="-transaction-body-wrapper">
                                                                        <div className="-amount -deposit">{Number(listitem.credit || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} บาท</div>
                                                                        <div className="-datetime">{moment(listitem.datecreate).format('DD/MM/YY') + " - " + moment(listitem.datecreate).format('HH:mm') + " น."} </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div
                    className="x-modal modal -v2 show"
                    id="providerUserModalMobile"
                    tabIndex={-1}
                    role="dialog"
                    data-container="#providerUserModalMobile"
                    aria-modal="true"
                >
                    <div
                        className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button"
                        role="document"
                    >
                        <div className="modal-content -modal-content">
                            <button
                                type="button"
                                className="close f-1 "
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="fas fa-times" />
                            </button>
                            <div className="modal-header -modal-header">
                                <div className="x-modal-mobile-header">
                                    <div className="-header-mobile-container">
                                        <h3 className="x-title-modal mx-auto text-center d-inline-block">
                                            ชวนเพื่อน
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body -modal-body">
                                <div id="accountProviderUser" className="x-account-provider ">
                                    <div
                                        data-animatable="fadeInModal"
                                        className="-account-provider-container animated fadeInModal"
                                    >
                                        <div className="-group-trace-wrapper">
                                            <div className="x-profile-group-trace-condition ">
                                                <div className="-card-condition-wrapper">
                                                    <div className="-card-condition-heading">
                                                        <span className="-title">
                                                            รับลิงค์ชวนเพื่อน
                                                        </span>
                                                    </div>
                                                    <div className="-card-condition-description">
                                                        กดที่ลิงค์ <span className="-highlight">
                                                            <a href={() => false} style={{ cursor: "pointer" }} onClick={() => this.copyCode()} className="-copy-wrapper js-copy-to-clipboard" data-container="shareAccountProfileBankInfo" data-message="คัดลอกแล้ว!" >
                                                                {linkaff}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <p className="-note">รายชื่อที่มี
                                                        <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                            className="-ic"
                                                            style={{ marginLeft: "5px" }}
                                                            width={"20px"}
                                                            alt=""
                                                        />  ครบเงื่อนใขการเติมเงินขั่นต่ำ 100 บาทแล้ว </p>
                                                    <span className="-title">
                                                        คุณได้รับเครดิตชวนเพื่อน<span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> บาท (คำนวณทุกวันอาทิตย์ เวลา 00.00น.)
                                                    </span>
                                                    {/* <span className="-title">
                            คุณได้รับเครดิตยอดเสีย<span className="-title" style={{ color: "#d9ad70" }}  > {cashoutSet != null ? cashoutSet.percent : "0"}  </span> บาท (คำนวณทุกวันอาทิตย์ เวลา 00.00น.)
                          </span> */}

                                                </div>
                                                <span className="-title">
                                                    คุณได้เปอเซนต์  <span className="-title" style={{ color: "#d9ad70" }}  >{tblprofile.AffPercent}%</span> จากยอดเสีย
                                                </span>
                                                <div className="-outer-history-wrapper" style={{ marginTop: "10px" }} >
                                                    <div className="x-bill-history-container">
                                                        <div
                                                            className="wg-container wg-container__wg_bill_history wg--loaded"
                                                            data-widget-name="wg_bill_history"
                                                            data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                                            data-widget-user-options='{"page":1}'
                                                        >
                                                            <div className="wg-content" style={{ display: (this.state.useradvice.length === 0) ? "" : "none" }}>
                                                                <div className="-no-result-wrapper mt-3">
                                                                    <div className="-heading-title">
                                                                        <i className="fas fa-times-circle -icon" />
                                                                        <div className="-title">ไม่พบข้อมูล</div>
                                                                        <div className="-sub-title" style={{ color: "black" }}>คุณยังไม่มีข้อมูลการชวนเพื่อนค่ะ</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="wg-content" style={{ display: (this.state.useradvice.length === 0) ? "none" : "" }}>
                                                                <table className="table table-borderless table-striped">
                                                                    <tbody>
                                                                        {this.state.useradvice.map((listitem, i) => (
                                                                            <tr key={i} id={listitem.tid}>
                                                                                <td className="-description-body-wrapper">
                                                                                    <div className="-title-wrapper">

                                                                                        {i + 1 + "."} <span className="-title" style={{ marginLeft: "0px" }}> {listitem.playerid}

                                                                                            {(listitem.checked !== 1) ? "" : <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                                                                className="-ic"
                                                                                                style={{ marginRight: "5px" }}
                                                                                                width={"20px"}
                                                                                                alt=""
                                                                                            />}
                                                                                        </span>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="-transaction-body-wrapper">
                                                                                    <div className="-datetime">{moment(listitem.DateCreate).format('DD/MM/YY') + " - " + moment(listitem.DateCreate).format('HH:mm') + " น."} </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                </>
        );
    }
}
export default App;
